// extracted by mini-css-extract-plugin
export default {"fade-in-section":"FadeInSection_fade-in-section__2BUAz","is-visible":"FadeInSection_is-visible__yhtd2"};